// @flow

import { connect } from 'react-redux';
import type { State } from 'store/types';
import { withRouter } from 'react-router-dom';
import Project from './Project';
import actions from '../../duck/actions';

function mapStateToProps(state: State) {
  return {
    isDarkTheme: state.app.isDarkTheme,
  };
}

const mapDispatchToProps = dispatch => ({
  switchTheme: isDarkTheme => dispatch(actions.switchTheme(isDarkTheme)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Project));



// WEBPACK FOOTER //
// ./src/view/screens/Project/index.js